// extracted by mini-css-extract-plugin
export default {"container":"sideMenu_container__olN36","hidden":"sideMenu_hidden__hDSiQ","content":"sideMenu_content__04qy0","toggleButton":"sideMenu_toggleButton__rPpNc"};